import { createSlice } from "@reduxjs/toolkit";
import { updateDriver } from "../thunks/updateDriverThunk";

const updateDriverSlice = createSlice({
  name: "driver",
  initialState: {
    status: "idle", // 'idle' | 'loading' | 'success' | 'error'
    error: null,
    driver: null,
  },
  reducers: {
    resetUpdateDriverStatus: (state) => {
      state.status = "idle";
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(updateDriver.pending, (state) => {
        state.status = "loading";
        state.error = null;
      })
      .addCase(updateDriver.fulfilled, (state, action) => {
        state.driver = action.payload;
        state.status = "success";
        state.error = null;
      })
      .addCase(updateDriver.rejected, (state, action) => {
        state.status = "error";
        state.error = action.payload;
      });
  },
});

export const { resetUpdateDriverStatus } = updateDriverSlice.actions;
export default updateDriverSlice.reducer;
